import { api } from "./api";
import { COUNTRIES } from "./countries";

// Browsing-region helper — session-scoped (sessionStorage + session cookie):
// re-detected from the visitor's IP on each new browser session, so travel or
// VPN changes never lock anyone to a prior country. The server is authoritative
// (IP detection / deliberate override cookie); this module only caches the
// resolved value per tab session and offers the deliberate "Change region" path.
const KEY = "mrp_region_session";
let inflight = null;

export const countryName = (cc) => COUNTRIES.find(([c]) => c === cc)?.[1] || cc || "your region";

// Default discovery map center per country (fallback: Toronto).
const REGION_CENTERS = {
  CA: { lat: 43.6532, lng: -79.3832, label: "Toronto, ON" },
  US: { lat: 40.7128, lng: -74.006, label: "New York, NY" },
};
export const regionCenter = (cc) => REGION_CENTERS[cc] || REGION_CENTERS.CA;

export function getRegion() {
  try {
    const cached = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (cached && typeof cached === "object" && "country" in cached) return Promise.resolve(cached);
  } catch { /* storage unavailable */ }
  if (!inflight) {
    inflight = api.geoRegion()
      .then((r) => ({ country: r.country || null, source: r.source || null }))
      .catch(() => ({ country: null, source: null }))
      .then((info) => {
        try { sessionStorage.setItem(KEY, JSON.stringify(info)); } catch { /* ignore */ }
        inflight = null;
        return info;
      });
  }
  return inflight;
}

// Deliberate region switch — validated server-side, stored as a session cookie.
export async function setRegion(country) {
  const r = await api.setRegionPreference(country);
  const info = { country: r.country, source: "override" };
  try { sessionStorage.setItem(KEY, JSON.stringify(info)); } catch { /* ignore */ }
  return info;
}

// Back to automatic IP detection.
export async function resetRegion() {
  await api.clearRegionPreference().catch(() => {});
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
  return getRegion();
}
